/*
 * Ce qu'une ligne AFFICHÉE désigne, et la file d'écriture que les deux surfaces partagent.
 *
 * Une ligne affichée peut porter plusieurs lignes Shopify : la remise du Discovery Set
 * coupe une même variante en deux (snippet `mm-cart-line-group`). Changer sa quantité
 * remet tout le groupe d'un coup, en une seule écriture `/cart/update.js` : la première
 * clé reçoit la quantité voulue, les autres zéro, et Shopify re-découpe ensuite selon la
 * remise. L'écriture vise les CLÉS et jamais la position, que le cadeau décale en
 * s'insérant en tête ; la documentation Shopify recommande elle aussi la clé dès qu'une
 * variante occupe plusieurs lignes.
 *
 * Le module est un SINGLETON idempotent : deux sections le chargent (le tiroir et la page
 * /cart), et une seconde exécution qui réaffecterait l'objet remettrait `pending` et
 * `running` à zéro au milieu d'une écriture en vol.
 *
 * La file est UNE pour toute la page. Le tiroir et la page /cart avaient chacun la leur :
 * un + du tiroir pendant une écriture de la page partait d'un DOM que l'autre allait
 * remplacer, et le dernier arrivé gagnait. Un rejet ne l'empoisonne pas : il est rendu à
 * l'appelant, qui l'affiche, et la chaîne repart sur une promesse tenue.
 */
window.MMCartLines = window.MMCartLines || {
  pending: Promise.resolve(),
  running: 0,

  updates(keys, quantity) {
    return Object.fromEntries(keys.split(',').map((key, index) => [key, index === 0 ? quantity : 0]));
  },

  enqueue(task) {
    this.running += 1;
    const run = this.pending.then(task);
    this.pending = run.then(
      () => {
        this.running -= 1;
      },
      () => {
        this.running -= 1;
      }
    );
    return run;
  },

  // Vrai quand plus rien n'est en attente : le tiroir s'en sert pour appliquer tout de
  // suite le contenu d'un ajout au lieu de l'ouvrir sur son état d'avant.
  get idle() {
    return this.running === 0;
  },
};
